import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=bce1b8f6&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bce1b8f6')) {
      api.createRecord('bce1b8f6', component.options)
    } else {
      api.reload('bce1b8f6', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=bce1b8f6&", function () {
      api.rerender('bce1b8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CZlkkF6eo63Y/JS/comp/ErrorMessage.vue"
export default component.exports